import { render, staticRenderFns } from "./VisitServiceArea.vue?vue&type=template&id=54af4da5"
import script from "./VisitServiceArea.vue?vue&type=script&lang=js"
export * from "./VisitServiceArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports